<!--title-->
<h2 mat-dialog-title>
	<mat-icon class="me-2">{{model.icon}}</mat-icon>
	<span>{{model.title}}</span>
</h2>

<!--content-->
<mat-dialog-content>
	<p>{{model.text}}</p>

	<!--form-->
	<form [formGroup]="form" class="pt-2" *ngIf="model.notesEnabled">
		<mat-form-field>
			<mat-label>Notes</mat-label>
			<textarea matInput formControlName="notes" rows="2"></textarea>
			<mat-error *ngIf="notes.errors?.required && notes.touched">
				{{'Commons.Validation.Required' | translate : { field: "Notes" } }}
			</mat-error>
		</mat-form-field>
	</form>
</mat-dialog-content>

<!--actions-->
<mat-dialog-actions>
	<button mat-flat-button color="accent" (click)="confirm()" [disabled]="form.enabled && !form.valid">
		<mat-icon class="mr-2">done</mat-icon>
		{{model.okButtonText}}
	</button>
	<button *ngFor="let btn of model?.additionalButtons" mat-flat-button [color]="btn.color || 'accent'" (click)="confirm(btn.action)">
		<mat-icon class="mr-2">{{btn.icon || 'done'}}</mat-icon>
		{{btn.text}}
	</button>
	<button type="button" mat-dialog-close mat-button>
		{{model.cancelButtonText}}
	</button>
</mat-dialog-actions>